<template>
	<div class="forumPageBox">
		<!-- 头部 -->
		<div class='header'>
			<div class="header_tit">
				<div class="header_tabbar">
					<div v-for="(tit_tabItem,index) in title_tabbar" :key="index">
						<a href="#" @click="active_tabFn(index)" :class="tit_tabActive == index ? 'active' : ''">{{tit_tabItem}} <span
							 class="underline" v-show="tit_tabActive == index ? true : false"></span></a>
					</div>
				</div>
				<div class="rightIcon">
					<img src="../assets/img/ellipsisBlack.png" alt="" @click="go_grzx()">
				</div>
				<div class="btnTit" v-show="selectItem">
					<ul class="select_item">
						<li v-for="(item,index) in selectItemList" @click="query_select(item.type,item.txt)" :class="queryIndex == item.type ? 'activeQuery' : ''">
							<span>{{item.txt}}</span>
							<img v-show="queryIndex == item.type ? true : false" src="../assets/img/query.png" alt="" />
						</li>
					</ul>
				</div>
			</div>
			<div class="searchFatherBox aa" v-show="tit_tabActive == 0? true:false">
				<img src="../assets/img/searchIcon.png" alt="" class="searchIcon" :style="focusbind ? 'left:10px' : ''">
				<input type="text" v-model="inputVal" value="" placeholder="请输入筛选内容" @keyup.13="jumpSearchResult(inputVal,0)"
				 :style="focusbind ? 'text-align:left' : ''" @focus="onFocus()" @blur="onBlur()" />
			</div>
			<div class="searchFatherBox bb" v-show="tit_tabActive == 1? true:false">
				<img src="../assets/img/searchIcon.png" alt="" class="searchIcon" :style="focusbind ? 'left:10px' : ''">
				<input type="text" v-model="inputVal" value="" placeholder="请输入筛选内容" @keyup.13="jumpSearchResult(inputVal,1)"
				 :style="focusbind ? 'text-align:left' : ''" @focus="onFocus()" @blur="onBlur()" />
			</div>
		</div>
		
			<swiper class="swiper_tab01 parent_swip" :options="swiperOption_tab01" ref="mySwiper_book">
				<swiper-slide>
					<div>
						<!-- 版块名称 -->
						<div class="swiper_box">
							<swiper class="swiper" :options="jb_swiperOption">
								<swiper-slide v-for="(item,idx) in category_list">
									<div class="swiper_itembox">
										<span class="swiper_border_yellow" v-if="idx != 2? true: false">{{item.title}}</span>
										<span class="swiper_border_puper" v-if="idx == 2? true: false"><i class='rotate_txt'>C</i><i class='rotate_txt'>N</i>控</span>
									</div>
									<div class="swiper_bkList swiper_bgc_yellow  swiper_border_yellow" :class="idx == 0? 'swiper_bgc_yellow  swiper_border_yellow' :
										idx == 1? 'swiper_bgc_pink  swiper_border_pink' :
										idx == 2? 'swiper_bgc_puper  swiper_border_puper' : ''">
										<!-- <img v-if="idx == 0" src="../assets/img/forum_ys_yellow.png" alt="" class="abs_img">
									<img v-if="idx == 1" src="../assets/img/forum_ys_pink.png" alt="" class="abs_img">
									<img v-if="idx == 2" src="../assets/img/forum_ys.png" alt="" class="abs_img"> -->
										<div class="bkItem" v-for="(listItm,listIdx) in item.list" :key="listIdx" @click="bankuaijinghua_par(listItm.id,listItm.root_list)">
											<img :src="$api.$BASE_URL_img + listItm.cover_image" alt="">
											<p>{{listItm.title}}</p>
										</div>
									</div>
								</swiper-slide>
							</swiper>
						</div>
						<!-- 最新讨论 -->
						<div class="newToke">
							<h4>最新讨论</h4>
							<!-- @click="jumpUrlBKM" -->
						<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
							<div class="masageLists" @click="bankuaijinghua(item.id)" v-for="(item,idx) in newest_list" :key="idx">
								<div class="massage_top">
									<div class="massage_top_left">
										<p>{{item.title}}</p>
									</div>
								</div>
								<div class="massage_footer">
									<div class="massage_footer_left">
										<img :src="$api.$BASE_URL_img+item.cover_image" alt="">
										<span>{{item.category_name}}</span>
										<span class="timeInfo">{{formatDateTime(item.createtime)}}</span>
									</div>
									<div class="massage_footer_right">
										<img src="../assets/img/ltxiaoxi.png" alt="消息图标" />
										<span>{{item.comment_num}}</span>
									</div>
								</div>
							</div>
						</van-pull-refresh>
						</div>
					</div>
				</swiper-slide>
				<swiper-slide>
					<div>
						<!-- 版块名称 -->
						<div class="swiper_box">
							<swiper class="swiper" :options="jb_swiperOption">
								<swiper-slide v-for="(item,idx) in category_list_gl">
									<div class="swiper_itembox">
										<span class="swiper_border_yellow" v-if="idx != 2? true: false">{{item.title}}</span>
										<span class="swiper_border_puper" v-if="idx == 2? true: false"><i class='rotate_txt'>C</i><i class='rotate_txt'>N</i>控</span>
									</div>
									<div class="swiper_bkList swiper_bgc_yellow  swiper_border_yellow" :class="idx == 0? 'swiper_bgc_yellow  swiper_border_yellow' :
										idx == 1? 'swiper_bgc_pink  swiper_border_pink' :
										idx == 2? 'swiper_bgc_puper  swiper_border_puper' : ''">
										<img v-if="idx == 0" src="../assets/img/forum_ys_yellow.png" alt="" class="abs_img">
										<img v-if="idx == 1" src="../assets/img/forum_ys_pink.png" alt="" class="abs_img">
										<img v-if="idx == 2" src="../assets/img/forum_ys.png" alt="" class="abs_img">
										<div class="bkItem" v-for="(listItm,listIdx) in item.list" :key="listIdx" @click="bankuaijinghua_par(listItm.id,listItm.root_list)">
											<img :src="$api.$BASE_URL_img + listItm.cover_image" alt="">
											<p>{{listItm.title}}</p>
										</div>
									</div>
								</swiper-slide>
							</swiper>
						</div>
						<!-- 最新讨论 -->
						<div class="newToke">
							<h4>最新讨论</h4>
							<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
							<!-- @click="jumpUrlBKM" -->
							<div class="masageLists" @click="bankuaijinghua(item.id)" v-for="(item,idx) in newest_list_gl" :key="idx">
								<div class="massage_top">
									<div class="massage_top_left">
										<p>{{item.title}}</p>
									</div>
								</div>
								<div class="massage_footer">
									<div class="massage_footer_left">
										<img :src="$api.$BASE_URL_img+item.avatar" alt="">
										<span>{{item.category_name}}</span>
										<span class="timeInfo">{{formatDateTime(item.createtime)}}</span>
									</div>
									<div class="massage_footer_right">
										<img src="../assets/img/ltxiaoxi.png" alt="消息图标" />
										<span>{{item.comment_num}}</span>
									</div>
								</div>
							</div>
							</van-pull-refresh>
						</div>
					</div>
				</swiper-slide>
			</swiper>
		<!-- 底部 -->
		<div style="height: 1.5rem"></div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			const that = this
			return {
				title_tabbar: ["交流区", "管理区"],
				tit_tabActive: 0,
				//轮播图配置
				jb_swiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 0,
					loop: false,
				},
				category_list: [], //分类
				newest_list: [], //最新讨论
				category_list_gl: [], //管理 --- 分类
				newest_list_gl: [], //管理 --- 最新讨论
				inputVal: '', //搜索内容
				focusbind: false, //搜索
				swiperOption_tab01: {
					spaceBetween: 30,
					centeredSlides: true,
					direction: 'horizontal',
					autoplay: false,
					loop: false,
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					observer: false,
					observeParents: false,
					// prevButton: ".swiper-button-prev",
					// nextButton: ".swiper-button-next",
					//滑动之后回调函数
					on: {
						slideChangeTransitionStart: function() {
							var swiper = that.$refs.mySwiper_book.$swiper;
							console.log(swiper.activeIndex, 'swiper.activeIndex')
							that.$emit('slideTab', swiper.activeIndex)
							if (swiper.activeIndex == 0) {
								that.tit_tabActive = 0;
							} else if (swiper.activeIndex == 1) {
								that.tit_tabActive = 1;
							}
						},
					},
				},
				selectItemList: [{
					txt: '个人中心',
					type: 1,
				}],
				queryIndex: 0,
				selectItem: false,
				isLoading: false,
			}
		},
		computed: {
			// 定义swiper，在下面就可以引用这个swiper了；
			swiper: function() {
				return this.$refs.mySwiper_book.$swiper
			},
		},
		created() {
			this.forum_home(); //论坛主页
			this.tit_tabActive = this.$route.query.tit_tabActive || 0;
			if (this.$webapp.isAndroid) {
				console.log("安卓")
				let isdark = 1;
				this.range = window.android.setBarcolor(Boolean(isdark)); //获取亮度 --- 安卓
			} else if (this.$webapp.isiOS) {
				console.log("苹果")
				// window.webkit.messageHandlers.loginwx.postMessage('') // 苹果
			}
		},
		methods: {
			onRefresh() {
				setTimeout(() => {
					// Toast('已获取到最新数据');
					this.forum_home();
					this.isLoading = false;
				}, 1000);
			},
			// 论坛搜索
			jumpSearchResult(value, a) {
				this.inputVal = value;
				this.$router.push({
					path: '/forumSearchResult',
					query: {
						keyword: this.inputVal,
						status: a
					}
				})
			},
			active_tabFn(index) {
				console.log(index);
				this.tit_tabActive = index;
				if (index == 0) {
					this.swiper.slideTo(0, 0, false)
				} else if (index == 1) {
					this.swiper.slideTo(1, 0, false)
				}
			},
			jumpUrlBKM(id) {
				this.$router.push({
					path: '/tieziInfo',
					query: {
						tzxqInfoId: id
					}
				})
			},
			bankuaijinghua_par(id, authorId) {
				var loginInfo = localStorage.getItem('userInfoData') || null;
				if (loginInfo != null) {
					var loginUserState = JSON.parse(localStorage.getItem('userInfoData')).state;
				}
				console.log(authorId, loginUserState)
				if (authorId == 0) {
					this.$router.push({
						path: '/bankuaijinghua',
						query: {
							newestListId: id
						}
					})
					return false
				} else if (authorId == 1 && loginUserState == 2) {
					this.$router.push({
						path: '/bankuaijinghua',
						query: {
							newestListId: id
						}
					})
					return false
				} else if (authorId == 1 && loginUserState == 3) {
					this.$router.push({
						path: '/bankuaijinghua',
						query: {
							newestListId: id
						}
					})
					return false
				} else if (authorId == 2 && loginUserState == 1) {
					this.$router.push({
						path: '/bankuaijinghua',
						query: {
							newestListId: id
						}
					})
					return false
				} else {
					Toast('暂无权限')
				}

			},
			bankuaijinghua(id) {
				this.$router.push({
					path: '/tieziInfo',
					query: {
						tzxqInfoId: id
					}
				})
			},
			forum_home() {
				this.$axios.post(this.$api.forum_home).then(res => {
					this.category_list = res.data.data.category_list;
					this.newest_list = res.data.data.newest_list;
				})
				this.$axios.post(this.$api.forum_home_gl).then(res => {
					this.category_list_gl = res.data.data.category_list;
					this.newest_list_gl = res.data.data.newest_list;
				})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);

				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			onFocus() { //搜索框 获取焦点
				this.focusbind = true;
			},
			onBlur() { //搜索框 失去焦点
				if (this.inputVal) {
					this.focusbind = true;
				} else {
					this.focusbind = false;
				}
			},
			query_select(index, txt) {
				var _t = this;
				_t.queryIndex = index;
				_t.selectItem = !_t.selectItem;
				if (index == 1) {
					// 跳转到创建书单页面
					_t.$router.push({
						path: '/grzx'
					});
				}
			},
			go_grzx() {
				if (this.selectItem) {
					this.selectItem = false;
				} else {
					this.selectItem = true;
				}

			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.parent_swip {
		padding-top: 60px;
	}

	.van-tabbar-item--active {
		color: #ff4081 !important;
	}

	.forumPageBox {
		background-color: #fff;
		height: 100vh;
		color: #000;

		// 头部
		.header {
			height: 160px;
			// background-color: #ffdd2b;
			display: flex;
			position: relative;
			// background: url(../assets/tabbar/yun.png) no-repeat 7% 60px #ffdd2b;
			// background-size: 16%;
			background: url(../assets/img/myicon/indexBgc02.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			// 2020.10.22修改start
			position: fixed;
			top: 0;
			z-index: 100;
			// 2020.10.22修改end
			.header_tit {
				margin-top: 60px;
				width: 100vw;
				// height: 80px;
				position: relative;
				border-bottom: 1px solid #f0f0f0;
				/*no*/

				.header_tabbar {
					overflow: hidden;
					line-height: 80px;
					font-size: 32px;
					/*px*/
					color: #ffffff;

					div {
						width: calc(50% - 40px);
						padding-right: 40px;
						float: left;
						text-align: right;

						a {
							position: relative;
							color: #000;
						}

						a.active {
							color: #ffdd2b;
						}
					}

					div:last-child {
						text-align: left;
						float: right;
						text-align: left;
						padding-right: 0px;
					}

					div a .underline {
						width: 100px;
						height: 4px;
						background-color: #ffdd2b;
						position: absolute;
						bottom: -15px;
						left: 50%;
						transform: translateX(-50%);
					}
				}

				h4 {
					text-align: center;
					color: #ffffff;
					font-size: 38px;
					/*px*/
					line-height: 80px;
					font-weight: 400;
				}

				.rightIcon {
					img {
						position: absolute;
						top: 44%;
						right: 16px;
						transform: translateY(-50%);
						width: 55px;
					}
				}

				.btnTit {
					padding: 0;
					position: fixed;
					top: 75px;
					right: 20px;
					transform: translateY(-50%);
					z-index: 999;

					img {
						width: 55px;
					}

					.select_item {
						width: 220px;
						z-index: 9;
						// background-color: rgba(0,0,0,.05);
						// border-radius: 5px;
						line-height: 56px;
						padding: 5px 20px;
						box-shadow: 0 1px 4px 0 rgba(0, 0, 0, .3);
						/*no*/
						position: absolute;
						right: 0px;
						top: 58px;
						background: #fff;

						li {
							color: #9A9A9A;
							display: flex;
							align-items: center;
							justify-content: space-between;
							font-size: 28px;

							img {
								width: 30px;
							}
						}
					}
				}
			}

			.searchFatherBox {
				position: absolute;
				bottom: -50px;
				left: 50%;
				transform: translateX(-50%);
				z-index: 99;

				.searchIcon {
					width: 30px;
					position: absolute;
					top: 20px;
					left: 235px;
				}

				input {
					width: 90vw;
					background-color: #fff;
					border-radius: 70px;
					height: 70px;
					padding-left: 60px;
					box-sizing: border-box;
					text-align: center;
					-webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .12);
					/*no*/
					-moz-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .12);
					/*no*/
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, .12);
					/*no*/
					color: #a3a3a3;
					font-size: 32px;
					/*px*/
				}
			}
		}

		// 板块
		.swiper_box {
			background-color: #fff;
			// 2020.10.22修改start
			// position: fixed;
			// top: 150px;
			margin-top: 140px;
			// 2020.10.22修改end
			.swiper-wrapper {
				height: 300px;
			}

			//轮播
			.swiper-container {
				height: 100%;
				background-color: #fff;

				.swiper-slide {
					width: 84% !important;
					margin: 20px 10px !important;
					display: flex;

					.swiper_itembox {
						span {
							margin-top: 40px;
							margin-left: 20px;
							padding: 10px 0;
							padding-left: 10px;
							display: inline-block;
							height: 140px;
							width: 40px;
							background-color: #fff;
							border-top-left-radius: 12px;
							/*no*/
							border-bottom-left-radius: 12px;
							;
							/*no*/
						}
					}

					.swiper_border_yellow {
						-webkit-box-shadow: 1px 4px 15px 0px rgba(245, 208, 123, .3);
						/*no*/
						-moz-box-shadow: 1px 4px 15px 0px rgba(245, 208, 123, .3);
						/*no*/
						box-shadow: 1px 4px 15px 0px rgba(245, 208, 123, .3);
						/*no*/
					}

					.swiper_border_pink {
						-webkit-box-shadow: 1px 4px 15px 0px rgba(255, 77, 137, .3);
						/*no*/
						-moz-box-shadow: 1px 4px 15px 0px rgba(255, 77, 137, .3);
						/*no*/
						box-shadow: 1px 4px 15px 0px rgba(255, 77, 137, .3);
						/*no*/
					}

					.swiper_border_puper {
						-webkit-box-shadow: 1px 4px 15px 0px rgba(219, 132, 235, .3);
						/*no*/
						-moz-box-shadow: 1px 4px 15px 0px rgba(219, 132, 235, .3);
						/*no*/
						box-shadow: 1px 4px 15px 0px rgba(219, 132, 235, .3);

						/*no*/
						.rotate_txt {
							display: block;
							padding-top: 10px;
							padding-left: 15px;
							font-style: normal;
							-webkit-transform: rotate(90deg);
							-moz-transform: rotate(90deg);
							transform: rotate(90deg);
						}
					}

					.swiper_bgc_yellow {
						border: 1px solid #f5d07b;
						/*no*/
						background-color: #fffde9;
					}

					.swiper_bgc_pink {
						border: 1px solid #ff4d89;
						/*no*/
						background-color: #fff8fa;
					}

					.swiper_bgc_puper {
						border: 1px solid #d980eb;
						/*no*/
						background-color: #f8eeff;
					}

					.swiper_bkList {
						flex: 1;

						border-radius: 20px;

						border-radius: 20px;
						position: relative;
						height: 200px;
						padding: 20px 10px;

						.abs_img {
							width: 60px;
							position: absolute;
							top: -20px;
							left: -20px;
						}

						.bkItem {
							float: left;
							margin-right: 6px;
							text-align: center;
							font-size: 30px;
							/*px*/
							margin-top: 32px;
							color: #000;

							img {
								width: 120px;
								height: 120px;
							}
						}

						.bkItem:last-child {
							margin-right: 0;
						}
					}
				}
			}

		}


		//最新讨论
		.newToke {
			border-top: 10px solid #f0f0f0;
			padding: 0 16px 20px 16px;
			box-sizing: border-box;
			background-color: #fff;
			// 2020.10.22修改start
			// height: calc(100vh - 8.2rem);
			// overflow-y: auto;
			// margin-top: 6rem;
			// 2020.10.22修改end
			h4 {
				color: #000000;
				font-size: 34px;
				/*px*/
				line-height: 60px;
				background-color: #fff;
				padding-top: 20px;
			}

			.masageLists {
				border-bottom: 1px solid #f0f0f0;
				/*px*/
				padding: 20px 0;

				.massage_top {
					display: flex;
					.massage_top_left {
						font-size: 34px;
						/*px*/
						line-height: 60px;/*px*/
					}
				}

				.massage_footer {
					padding: 10px 0 5px;
					display: flex;

					.massage_footer_left {
						flex: 1;
						display: flex;
						flex-direction: row;
						align-items: center;

						img {
							vertical-align: middle;
							width: 40px;
							height: 40px;
							box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
						}

						span {
							padding: 0 20px;
							font-size: 24px;
							/*px*/
							color: #a3a3a3;
						}

						.timeInfo {
							padding: 0;
							font-size: 24px;
							/*px*/
							color: #999999;

							span {
								padding-right: 10px;
							}
						}
					}

					.massage_footer_right {
						width: 100px;
						text-align: right;
						position: relative;

						img {
							width: 35px;
							padding-right: 10px;
							position: absolute;
							right: 20px;
							top: 50%;
							transform: translateY(-50%);
						}

						span {
							display: inline-block;
							padding-top: 5px;
						}
					}



				}
			}
		}

	}
</style>
